import React, { useEffect, useState } from 'react';
import { colors } from './theme';
import RmaAnalyticsCard from './RmaAnalyticsCard';
import LoadingSpinner from './components/LoadingSpinner';

const API_BASE = process.env.REACT_APP_API_URL;

function LineChart({ data }) {
  if (!data || data.length === 0) return null;
  const max = Math.max(...data.map(d => d.ratio), 0.002);
  const points = data.map((d, idx) => {
    const x = (idx / (data.length - 1)) * 100;
    const y = 100 - (d.ratio / max) * 100;
    return `${x},${y}`;
  }).join(' ');
  return (
    <svg viewBox="0 0 100 100" style={{ width: '100%', height: '200px', background: colors.sectionBackground }}>
      <polyline fill="none" stroke={colors.accent} strokeWidth="2" points={points} />
    </svg>
  );
}

export default function RmaReport() {
  const params = new URLSearchParams(window.location.search);
  const [year, setYear] = useState(params.get('year') || 'current');
  const [stats, setStats] = useState(null);
  const [warranty, setWarranty] = useState(null);
  const [history, setHistory] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/analytics/rma?year=${year}`).then(r => r.json()).then(setStats).catch(() => {});
    fetch(`${API_BASE}/analytics/warranty-ratio?year=${year}`).then(r => r.json()).then(setWarranty).catch(() => {});
  }, [year]);

  useEffect(() => {
    fetch(`${API_BASE}/analytics/warranty-ratio/history`).then(r => r.json()).then(setHistory).catch(() => {});
  }, []);

  const handlePrint = () => window.print();

  if (!stats || !warranty || !history) {
    return (
      <div style={{ padding: '1rem', backgroundColor: colors.sectionBackground, color: colors.background, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: colors.sectionBackground, minHeight: '100vh', color: colors.background }}>
      <header style={{ backgroundColor: colors.primary, color: colors.background, padding: '0.75rem 1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ margin: 0 }}>RMA Report</h1>
        <button onClick={handlePrint} style={{ backgroundColor: colors.background, color: colors.text, border: 'none', padding: '0.5rem 1rem', borderRadius: '4px', cursor: 'pointer' }}>Print</button>
      </header>
      <div style={{ padding: '1rem', color: colors.text }}>
        <RmaAnalyticsCard stats={stats} warranty={warranty} year={year} setYear={setYear} />
        <section style={{ marginTop: '1rem' }}>
          <h3 style={{ margin: '0 0 0.5rem 0' }}>Warranty Ratio Over Time</h3>
          <LineChart data={history} />
        </section>
      </div>
    </div>
  );
}
